
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div className='ui stackable grid receipe'>
  <div className='ui sixteen wide column c'>
    Basilikum-Joghurt-Mousse mit Erdbeerpüree
  </div>
  <div className='ui six wide column a' />
  <div className='ui ten wide column b'>Von</div>
  <div className='ui six wide column a'>1 Bund Zwerg- oder Thai-Basilikum</div>
  <div className='ui ten wide column b'>die Blättchen abzupfen und hacken.</div>
  <div className='ui six wide column a'>500 g Erdbeeren</div>
  <div className='ui ten wide column b'>
    waschen, das Grün entfernen und 250 g mit
  </div>
  <div className='ui six wide column a'>1/2 Banane</div>
  <div className='ui ten wide column b'>und</div>
  <div className='ui six wide column a'>500 g Joghurt</div>
  <div className='ui ten wide column b'>und dem Basilikum pürieren.</div>
  <div className='ui six wide column a'>10 g Guarkernmehl</div>
  <div className='ui ten wide column b'>einrühren.</div>
  <div className='ui six wide column a' />
  <div className='ui ten wide column b'>Den Rest der Erdbeeren achteln.</div>
  <div className='ui six wide column a'>40 g 90-prozentige Schokolade</div>
  <div className='ui ten wide column b'>mit dem Messer grob raspeln.</div>
  <div className='ui six wide column a' />
  <div className='ui ten wide column b'>
    Basilikum-Joghurt-Mousse in Gläser abfüllen und mit Erdbeeren und
    Schokoraspeln servieren.
  </div>
    </div>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;